import {AfterViewInit, Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-map-selection',
  templateUrl: './map-selection.component.html',
  styleUrls: ['./map-selection.component.css'],
  standalone: false
})
export class MapSelectionComponent implements OnInit, AfterViewInit {

  @Input('att')
  private att: any;
  public mapCenter: any;
  public map!: any;
  public marker!: any;

  constructor(public modal: NgbActiveModal) {
    this.mapCenter = {
      lat: null, lng: null
    };
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    let self = this;
    navigator.geolocation.getCurrentPosition((position) => {
      console.log(position);
      this.mapCenter = {
        lat: position.coords.latitude,
        lng: position.coords.longitude
      }
      this.map = new google.maps.Map(
        document.getElementById("map") as HTMLElement,
        {
          zoom: 14,
          center: this.mapCenter,
        }
      );
      //Initial marker
      this.marker = new google.maps.Marker({
        position: this.mapCenter,
        map: self.map
      });
      //change marker
      this.map.addListener('click', (e: any) => {
        if (self.marker) {
          self.marker.setMap(null);
        }
        this.mapCenter = e.latLng.toJSON();
        this.marker = new google.maps.Marker({
          position: this.mapCenter,
          map: self.map
        });
      });
    });
  }

  public add() {
    let result = {
      latitud: this.marker.getPosition()?.toJSON().lat,
      longitud: this.marker.getPosition()?.toJSON().lng,
      valortxt: this.mapCenter.address
    }
    this.modal.close(result);
  }
}
